import { FC } from "react";

type MiniCloseIconProps = {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
  style?: React.CSSProperties;
};

export const MiniCloseIcon: FC<MiniCloseIconProps> = ({
  width = 16,
  height = 16,
  fill = "rgba(153, 153, 153, 1)",
  className,
  style,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={className}
      style={style}
    >
      <path
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0615 8.00013L13.0306 11.9693L11.97 13.0299L8.00072 9.06067L4.03057 13.03L2.97003 11.9692L6.94006 8.00001L2.96997 4.0299L4.03063 2.96924L8.00084 6.93947L11.97 2.97113L13.0306 4.03191L9.0615 8.00013Z"
      />
    </svg>
  );
};
